import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from ".././Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));
const TITLE = "Berapa Hari Lagi Olimpiade 2028 - Hitung Mundur Olimpiade";
const DESCRIPTION = "Berapa hari lagi Olimpiade 2028? Hitung mundur Olimpiade memungkinkan Anda mengetahui waktu yang tersisa hingga dimulainya acara olahraga terpenting di dunia. Ikuti hitung mundur dan tetap terinformasi mengenai tanggal pasti dimulainya Olimpiade.";
const KEYWORDS = "Olimpiade 2028, berapa hari lagi Olimpiade, hitung mundur Olimpiade, kapan Olimpiade, Olimpiade Los Angeles, Olimpiade 2028, hitung mundur Olimpiade, jadwal Olimpiade, pertandingan Olimpiade";
const OG_URL = "https://do-calculate.com/articles-id/olympics";
function OlympicsCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const olympicsDate = new Date("2028-07-26T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(olympicsDate));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(olympicsDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>Berapa Hari Lagi Olimpiade 2028</h1>
            <Suspense fallback={<div>Loading...</div>}>
                <BlinkingText text="Berapa hari lagi Olimpiade: Diperkirakan turnamen dimulai hari Kamis 26 Juli 2028 di Los Angeles, Amerika Serikat." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <thead>
                            <tr>
                                <th>Hari</th>
                                <th>Jam</th>
                                <th>Menit</th>
                                <th>Detik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days}</td>
                                <td>{timeLeft.hours}</td>
                                <td>{timeLeft.minutes}</td>
                                <td>{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Informasi tentang Olimpiade 2028</h3>
                    <p>
                        Olimpiade adalah acara olahraga global yang diadakan setiap empat tahun sekali, di mana para atlet dari seluruh penjuru dunia bersaing dalam berbagai cabang olahraga. Olimpiade 2028 akan digelar di Los Angeles, Amerika Serikat, dan diharapkan menyajikan kompetisi yang sangat seru dalam berbagai cabang olahraga. Seluruh dunia menantikan acara ini dengan penuh semangat.
                    </p>
                    <p>
                        Edisi Olimpiade kali ini akan sangat istimewa karena Olimpiade kembali ke Amerika Serikat setelah 32 tahun sejak penyelenggaraan terakhir di Atlanta pada tahun 1996.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Loading...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col">
                    <Suspense fallback={<div>Loading...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
        </div>
    );
}
export default OlympicsCountdown;
